/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramNotificationsPublicControllerUnsubscribeMutationRequest,
  TelegramNotificationsPublicControllerUnsubscribeMutationResponse,
  TelegramNotificationsPublicControllerUnsubscribeQueryParams,
} from '../../types/TelegramNotificationsPublicControllerUnsubscribe.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramNotificationsPublicUnsubscribe } from '../../methods/telegramNotificationsPublicUnsubscribe.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramNotificationsPublicUnsubscribeMutationKey = () =>
  [{ url: '/api/telegram/notifications/unsubscribe' }] as const;

export type TelegramNotificationsPublicUnsubscribeMutationKey = ReturnType<
  typeof telegramNotificationsPublicUnsubscribeMutationKey
>;

/**
 * {@link /api/telegram/notifications/unsubscribe}
 */
export function useTelegramNotificationsPublicUnsubscribe<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramNotificationsPublicControllerUnsubscribeMutationResponse,
      ResponseErrorConfig<Error>,
      {
        data?: TelegramNotificationsPublicControllerUnsubscribeMutationRequest;
        params?: TelegramNotificationsPublicControllerUnsubscribeQueryParams;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramNotificationsPublicControllerUnsubscribeMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramNotificationsPublicUnsubscribeMutationKey();

  return useMutation<
    TelegramNotificationsPublicControllerUnsubscribeMutationResponse,
    ResponseErrorConfig<Error>,
    {
      data?: TelegramNotificationsPublicControllerUnsubscribeMutationRequest;
      params?: TelegramNotificationsPublicControllerUnsubscribeQueryParams;
    },
    TContext
  >(
    {
      mutationFn: async ({ data, params }) => {
        return telegramNotificationsPublicUnsubscribe(data, params, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
